'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useCallback } from 'react';
import { registerPasskey } from '@dynamic-labs-sdk/client';
import { useDynamicClient } from '../../../client/client.js';

/**
 * Register passkey
 *
 * @returns Function to register passkey
 *
 * @example
 * ```tsx
 * const App = () => {
 *   const registerPasskey = useRegisterPasskey();
 *
 *   return (
 *     <button
 *       onClick={() => registerPasskey()}
 *     >
 *       Register passkey
 *     </button>
 *  );
 * }
 */
const useRegisterPasskey = () => {
    const client = useDynamicClient();
    return useCallback(() => __awaiter(void 0, void 0, void 0, function* () { return registerPasskey(client); }), [client]);
};

export { useRegisterPasskey };
